var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"square-healthy"},[_c('table',{staticClass:"table-healthy"},[_c('tr',_vm._l((_vm.columns),function(name){return _c('th',{key:name},[_vm._v(_vm._s(name))])}),0),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.healthy))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }